import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';
import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'MuiSunrunComparisonTableMobile' })(
  ({ brandColors, breakpoints, typography }) => ({
    table: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      backgroundColor: brandColors.white,
    },
    navigation: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      padding: `${typography.pxToRem(12)} ${typography.pxToRem(130.5)}`,
      [breakpoints.down(ScreenSize.SMALL)]: {
        padding: `${typography.pxToRem(12)} ${typography.pxToRem(24)}`,
      },
    },
    navigationItem: {
      width: typography.pxToRem(98.33),
      height: typography.pxToRem(56),
      fontSize: '1rem',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      color: brandColors.mediumBlue,
      backgroundColor: 'transparent',
      borderRadius: '2rem',
      alignItems: 'center',
      [breakpoints.down(ScreenSize.SMALL)]: {
        height: typography.pxToRem(49),
        fontSize: typography.pxToRem(14),
      },
    },
    navigationItemActive: {
      backgroundColor: brandColors.black,
      color: brandColors.white,
    },
    body: {
      display: 'flex',
      flexDirection: 'column',
    },
    title: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      padding: `${typography.pxToRem(40)} ${typography.pxToRem(
        40
      )} ${typography.pxToRem(16)} ${typography.pxToRem(40)} `,
      fontSize: typography.pxToRem(32),
      fontWeight: 500,
      margin: 0,
    },
    subtitle: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      padding: `0 ${typography.pxToRem(40)} ${typography.pxToRem(
        32
      )} ${typography.pxToRem(40)} `,
      margin: 0,
      fontSize: typography.pxToRem(16),
      fontWeight: 400,
      color: brandColors.tintsNeutral10,
      maxWidth: typography.pxToRem(520),
      [breakpoints.down(ScreenSize.SMALL)]: {
        maxWidth: '90%',
      },
    },
    header: {
      display: 'flex',
      flexDirection: 'column',
    },
    benefits: {
      display: 'flex',
      flexDirection: 'column',
      margin: `0 ${typography.pxToRem(12.67)}`,
      //height: typography.pxToRem(351),
      overflow: 'scroll',
      [breakpoints.down(ScreenSize.LARGE)]: {
        //height: typography.pxToRem(387),
        margin: 0,
      },
    },
    cta: {
      padding: `0 ${typography.pxToRem(40)} ${typography.pxToRem(
        40
      )} ${typography.pxToRem(40)}}`,
      [breakpoints.down(ScreenSize.LARGE)]: {
        bottom: typography.pxToRem(32),
      },
      '& .MuiButton-button': {
        '& .MuiButton-PrimaryBluePill': {
          textDecoration: 'none',
          height: typography.pxToRem(50),
          padding: '18px 0',
          width: '100%',
          '&:hover': {
            textDecoration: 'underline',
          },
        },
      },
    },
    benefitContainer: {
      padding: `0 ${typography.pxToRem(40)} ${typography.pxToRem(
        24
      )} ${typography.pxToRem(40)} `,
      '&:last-child': {
        paddingBottom: typography.pxToRem(32),
      },
    },
    benefit: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      marginTop: typography.pxToRem(12.5),
    },
    benefitTitle: {
      fontSize: typography.pxToRem(16),
    },
    benefitName: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      justifyContent: 'center',
      [breakpoints.down(ScreenSize.LARGE)]: {
        fontSize: typography.pxToRem(16),
      },
    },
    benefitIcon: {
      display: 'flex',
      flexDirection: 'column',
      width: typography.pxToRem(23),
      marginRight: typography.pxToRem(18),
    },
    favorite: {
      width: '100%',
      height: typography.pxToRem(31),
      backgroundColor: '#FCE838',
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      color: brandColors.mediumBlue,
      fontSize: '1rem',
      fontWeight: 500,
      justifyContent: 'center',
    },
  })
);

export default useStyles;
